import showSpinner from '@services/addSpinnerOnQueryStarted';
import { toQueryString } from '@services/path';

import {
    applyUserTimeZoneConversionMapping,
    removeBrowserTimeZoneConversionMapping,
} from '../bidProfiles/bidProfiles.service';

const BASE_PATH = 'api/v1/manager/Audit';

export const AUDIT_TAG = 'audit';
export const AUDIT_TAGS = [AUDIT_TAG];

/** @typedef {{ page: number; pageSize: number; search: string; selectedStatuses: string }} ManagerAuditQueryString */

/**
 * @param {import('@reduxjs/toolkit/dist/query/endpointDefinitions').EndpointBuilder<any, string, string>} builder
 * @returns {import('@reduxjs/toolkit/dist/query').QueryDefinition<
 *    ManagerAuditQueryString|void,
 *    any,
 *    any,
 *    { audits: VBD.IAudit[]; totalCount: number }
 * >}
 */
const getAll = (builder) => builder.query({
    query: (queryParams) => ({ url: `${BASE_PATH}${toQueryString(queryParams)}`, method: 'GET' }),
    async onQueryStarted(id, api) { await showSpinner(api); },
    transformResponse: (res) => ({
        audits: res.bidProfiles
            .map((audits) => {
                audits = applyUserTimeZoneConversionMapping(audits);
                return removeBrowserTimeZoneConversionMapping(audits);
            }),
        totalCount: res.totalCount,
    }),
    providesTags: AUDIT_TAGS,
});

export const endpointsAudit = (builder) => ({
    getAllBidProfileAudit: getAll(builder)
});
